module.exports = __webpack_public_path__ + "static/media/zl_2_8.c0bf410e.png";